import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useInfluencer } from '@client/new/hooks/use-influencer';
import { useUserStore } from '@client/new/stores/user.store';
import {
  toProfileCurrentUser,
  useProfileVM,
} from '../view-model/Profile.viewModel';
import { ProfileView } from './Profile.view';

type RouteParams = {
  influencerId?: string;
};

export const ProfilePage = (props: { params: RouteParams }) => {
  const { influencer } = useInfluencer();
  const { user } = useUserStore();
  const routeInfluencerId = props.params.influencerId;

  const vm = useProfileVM({
    routeInfluencerId,
    currentUser: toProfileCurrentUser(user),
    fallbackInfluencerId: influencer?.id,
  });

  return (
    <AsyncRenderer data={vm} renderer={(data) => <ProfileView {...data} />} />
  );
};
